import { Box, Heading, Text } from '@chakra-ui/react'
import React from 'react'

import { Container } from '@/components/Container'
import { Head } from '@/components/Head'
import { Header } from '@/components/Header'
import { Layout } from '@/components/Layout'

const Terms = () => {
  return (
    <Layout>
      <Head path="/terms" title="Terms & Conditions" />
      <Container>
        <Header />
        <Box mt="8">
          <Heading as="h1">Terms & Conditions</Heading>
          <Text mt="4" fontWeight="bold">
            CryptoUikiyoe is a distributed application that runs on the Ethereum network, using
            ERC-1155 smart contracts that allow users to acquire, buy and sell own and transfer, the
            unique digital artworks known as CryptoUikiyoe (hereafter &quot;CryptoUikiyoe&quot;)
            located at cryptoukiyoe.art (the &quot;Site&quot;).
          </Text>
          <Text fontWeight="bold">
            Sharacue (&quot;Sharacue&quot;, &quot;I&quot;, or &quot;me&quot;) is the party making
            the App available for you to use.
          </Text>
          <Text fontWeight="bold">
            &quot;Art&quot; means any art, design, and drawings that may be associated with a
            CryptoUikiyoe that you Own.
          </Text>
          <Text mt="4" fontWeight="bold">
            Users are solely responsible for the security and management of their own private
            Ethereum wallets and for the pre-authorization verification of all transactions and
            contracts. Furthermore, CryptoUkiyoe runs on an ERC-1155 smart contract on the Ethereum
            network provided by OpenSea, so there is no ability to undo, reverse, or restore
            transactions.
          </Text>
          <Text mt="4" fontWeight="bold">
            This website and its related services are provided on an &quot;as is&quot; and &quot;as
            available&quot; basis without warranty of any kind. by using this website, you are
            solely responsible for all transactions involving the CryptoUkiyoe digital collectibles.
          </Text>
          <Heading mt="8" as="h2" size="lg">
            Ownership; License.
          </Heading>
          <Text mt="4" fontWeight="bold">
            (a) Ownership.
          </Text>
          <Text fontWeight="bold">
            i. When you purchase a CryptoUkiyoe, you own only the NFT and not the associated Art.
            Each CryptoUkiyoe is associated with a non-fungible token (an &quot;NFT&quot;) on the
            Ethereum blockchain. When you acquire a CryptoUkiyoe, you own the NFT and not the
            associated Art. You may trade, sell, or distribute the NFTs for free; ownership of the
            NFTs is controlled solely by the Smart Contracts and Ethereum network.
          </Text>
          <Text fontWeight="bold">
            ii. I Own the Site, and the Site includes the Art. You acknowledge and agree that I owns
            all legal right, title and interest in and to all other elements of the Site, and all
            intellectual property rights therein.
          </Text>
          <Text mt="4" fontWeight="bold">
            (b) License to Art.
          </Text>
          <Text fontWeight="bold">
            i. General Use. Subject to your full and continuing compliance with these Terms,
            CryptoUkiyoe grants you a limited, worldwide, non-exclusive, non-transferable,
            royalty-free license to use, copy, and display the CryptoUkiyoe art you purchase solely
            for the following purposes. (a) your own personal, non-commercial use; (b) as part of a
            marketplace that permits the purchase and sale of CryptoUkiyoe purchased by you; or (c)
            as part of a third party website or application that permits the inclusion, engagement,
            or participation of CryptoUkiyoe purchased by you.
          </Text>
          <Text fontWeight="bold">
            ii. Non-Digital Commercial Use. Subject to your continued compliance with these Terms,
            CryptoUkiyoe grants you a limited, worldwide, non-exclusive, non-transferable license to
            use, copy, and display the CryptoUkiyoe Art purchased by you for the purpose of
            merchandising physical goods that includes, contains, or consists of the CryptoUkiyoe
            Art purchased by you.
          </Text>
        </Box>
      </Container>
    </Layout>
  )
}

export default Terms
